<script setup lang="ts">
import { ref } from 'vue';
import { ShieldCheck } from 'lucide-vue-next';
import { useAuth } from '@/composables/useAuth';
import { useNavigation } from '@/composables/useNavigation';

const { authError, isLoading, setupAdmin } = useAuth();
const { navigate } = useNavigation();

const form = ref({
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  passwordRepeat: ''
});

const localError = ref('');

async function submitSetup() {
  localError.value = '';
  if (form.value.password !== form.value.passwordRepeat) {
    localError.value = 'Die Passwoerter stimmen nicht ueberein.';
    return;
  }

  const ok = await setupAdmin(form.value);
  if (ok) navigate('family');
}
</script>

<template>
  <section class="mx-auto max-w-4xl px-4 py-8 md:px-6">
    <form class="rounded-[30px] bg-white p-6 shadow-soft md:p-8" @submit.prevent="submitSetup">
      <div class="flex items-center gap-3">
        <span class="grid h-14 w-14 place-items-center rounded-2xl bg-heart-mint text-heart-leaf">
          <ShieldCheck class="h-8 w-8" aria-hidden="true" />
        </span>
        <h1 class="text-3xl font-black text-heart-berry md:text-4xl">Ersteinrichtung</h1>
      </div>

      <p class="mt-4 text-lg font-bold leading-8 text-heart-ink">
        Lege den ersten Administrator fuer Freundedorf an.
      </p>

      <div class="mt-8 grid gap-5 md:grid-cols-2">
        <label class="block text-sm font-black text-heart-ink">Vorname<input v-model="form.firstName" class="focus-ring mt-2 min-h-14 w-full rounded-2xl border border-orange-100 px-4" autocomplete="given-name" required /></label>
        <label class="block text-sm font-black text-heart-ink">Nachname<input v-model="form.lastName" class="focus-ring mt-2 min-h-14 w-full rounded-2xl border border-orange-100 px-4" autocomplete="family-name" required /></label>
        <label class="block text-sm font-black text-heart-ink md:col-span-2">E-Mail<input v-model="form.email" class="focus-ring mt-2 min-h-14 w-full rounded-2xl border border-orange-100 px-4" type="email" autocomplete="email" required /></label>
        <label class="block text-sm font-black text-heart-ink">Passwort<input v-model="form.password" class="focus-ring mt-2 min-h-14 w-full rounded-2xl border border-orange-100 px-4" type="password" minlength="12" autocomplete="new-password" required /></label>
        <label class="block text-sm font-black text-heart-ink">Passwort wiederholen<input v-model="form.passwordRepeat" class="focus-ring mt-2 min-h-14 w-full rounded-2xl border border-orange-100 px-4" type="password" minlength="12" autocomplete="new-password" required /></label>
      </div>

      <p v-if="localError || authError" class="mt-5 rounded-2xl bg-rose-100 px-4 py-3 font-bold text-rose-800">
        {{ localError || authError }}
      </p>

      <button class="focus-ring mt-8 min-h-14 w-full rounded-2xl bg-heart-coral px-5 text-lg font-black text-white disabled:opacity-60" type="submit" :disabled="isLoading">
        Admin anlegen
      </button>
    </form>
  </section>
</template>
